import React from "react";
import styled from "@emotion/styled";
import { Wrapper } from "../Wrapper";
import { ArticleListItem } from "../ArticleListItem";

type Props = {
  posts: any[];
};

const Title = styled.h3`
  color: ${(props) => props.theme.colors.charcoal};
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 30px;
  text-align: center;
`;

const Container = styled.section`
  background: ${(props) => props.theme.colors.mist};
  padding: 90px 0 70px; // leave room for bottom margins on listItem
`;

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;
  margin: 0 auto;
  max-width: 400px;
  padding: 0;

  @media ${(props) => props.theme.bp.tabletUp} {
    max-width: none;
  }
`;

export const BlogMorePosts: React.FC<Props> = ({ posts }) => {
  // const url = category
  //   ? `${rootUrl}&filter[category_name]=${category}`
  //   : rootUrl;
  return (
    <Container>
      <Wrapper isLarge>
        <Title>More posts</Title>
        <List>
          {posts.map((post) => (
            <ArticleListItem article={post} key={post.id} />
          ))}
        </List>
      </Wrapper>
    </Container>
  );
};
